module.exports = __webpack_public_path__ + "static/img/YhLOGO.2d1e753.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YhLOGO.png
// module id = ZWtm
// module chunks = 1